import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { CheckoutTitleStyled } from '../CheckoutTitleStyled';
import { rem } from 'polished';

export const CheckoutTitleStyledOV = styled(CheckoutTitleStyled)`
    font-size: ${({ theme }) => theme.fontSizes.h4};
    color: ${({ theme }) => theme.colors.black};
    font-style: normal;
    font-weight: normal;
    font-family: ${({ theme }) => theme.fonts.fontBase};

    @media (min-width: ${breakpoints.sm}px) {
        font-size: ${({ theme }) => theme.fontSizes.h2};
        margin-top: ${rem(60)};
    }
`;
